import { __awaiter } from "tslib";
import { loadWebtexte } from "@phoenixreisen/gateway";
export const URL_OVERVIEW = "https://www.phoenixreisen.com/kataloge-online-lesen.html";
export const Model = {
    webtexte: null,
};
export function getWebtexte() {
    return __awaiter(this, void 0, void 0, function* () {
        const categories = [
            "katalogverwaltung__ueberschrift",
            "katalogverwaltung__angebot__text",
            "katalogverwaltung__angebot__ueberschrift",
            "katalogverwaltung__abonnements__text",
            "katalogverwaltung__abonnements__text__auswahl",
            "katalogverwaltung__abonnements__ueberschrift",
        ];
        return loadWebtexte(categories, "webtexte.praesente");
    });
}
export default Model;
